// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { tap, map } from 'rxjs/operators';
import { readParameterFromRouterSnapshot, GoAction, IAM_ROUTE } from '@app/core';
import { State, selectSelectedUsers } from './state';

@Injectable()
export class RoleScopeFormGuardService implements CanActivate {
  constructor(private store: Store<State>) {}

  canActivate(router: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const roleId = readParameterFromRouterSnapshot(router, 'id');
    if (roleId === undefined) {
      this.store.dispatch(new GoAction(['/', IAM_ROUTE]));
      return false;
    }
    const selectedUsers$ = this.store.pipe(select(selectSelectedUsers(roleId)));
    const hasSelectedUsers$ = selectedUsers$.pipe(map(selectedUsers => selectedUsers.length > 0));
    return hasSelectedUsers$.pipe(
      tap(hasSelectedUsers => {
        if (!hasSelectedUsers) {
          this.store.dispatch(new GoAction(['/', IAM_ROUTE, 'roles', roleId]));
        }
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/role-scope-form-guard.service.ts